import { render, staticRenderFns } from "./deng.vue?vue&type=template&id=1be87608&scoped=true&"
import script from "./deng.vue?vue&type=script&lang=js&"
export * from "./deng.vue?vue&type=script&lang=js&"
import style0 from "./deng.vue?vue&type=style&index=0&id=1be87608&lang=scss&scoped=true&"
import style1 from "./deng.vue?vue&type=style&index=1&id=1be87608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be87608",
  null
  
)

export default component.exports